module.exports = __webpack_public_path__ + "img/newchris-84.8e90b1b7.jpg";